import { createContext, useContext } from "react";
import { API_BASE } from "../api/base";


/**
 * Resolve image URLs: if the URL starts with /static/ it's served by the backend,
 * so prepend the API base. Otherwise return as-is (external URLs, data URIs, etc.).
 */
export function resolveImageUrl(url: string | null | undefined): string {
  if (!url) return "";
  if (url.startsWith("/static/")) return `${API_BASE}${url}`;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  // Reject dangerous protocols (javascript:, data:, vbscript:, etc.)
  return "";
}

export interface SiteConfig {
  color_primary: string;
  color_dark: string;
  color_accent: string;
  color_muted: string;
  color_light_bg: string;
  color_body_bg: string;
  color_footer_blog: string | null;
  font_heading: string;
  font_body: string;
  brand_name: string;
  brand_tagline: string | null;
  logo_url: string | null;
  footer_logo_url: string | null;
  blog_image_url: string | null;
  contact_email: string | null;
  contact_phone: string | null;
  contact_address: string | null;
  vat: string | null;
  vat_rate_percent: number;   // aliquota IVA attiva (0 = IVA non applicata)
  page_about_json: string | null;
  page_fiscal_json: string | null;
  page_contact_json: string | null;
}

export const defaultConfig: SiteConfig = {
  color_primary: "#12634A",
  color_dark: "#1C4B3B",
  color_accent: "#BF652E",
  color_muted: "#7A9E8E",
  color_light_bg: "#f0ede8",
  color_body_bg: "#ffffff",
  color_footer_blog: null,
  font_heading: "'Playfair Display', serif",
  font_body: "system-ui, -apple-system, sans-serif",
  brand_name: "GRANBORGO",
  brand_tagline: null,
  logo_url: null,
  footer_logo_url: null,
  blog_image_url: null,
  contact_email: "info@granborgo.com",
  contact_phone: "+4967629499360",
  contact_address: "Granborgo GmbH\nAn der Molkerei 8\n56288 Kastellaun, Deutschland",
  vat: "VAT DE462679696",
  vat_rate_percent: 0,
  page_about_json: null,
  page_fiscal_json: null,
  page_contact_json: null,
};

// Il provider sta in SiteConfigProvider.tsx: un file che esporta componenti
// deve esportare solo componenti (fast refresh), e qui vivono hook e funzioni.
export const SiteConfigContext = createContext<SiteConfig>(defaultConfig);

export function useSiteConfig() {
  return useContext(SiteConfigContext);
}
